import request from '@/utils/request'

/**
 * 获取拼团订单列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function listProductGroupOrder(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productGroup.listProductGroupOrder',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}